import Commons from '../../../../Services/Common/Common';

/**
 * PPE_BASIC_01 (보호구 등록/마스터) 스키마
 * 서버 응답: PascalCase (ErCd, EquipNm, Spec, Price, Unit, Remark, PaymentStandard, ManagerDepartment, ManagerId)
 * 그리드 데이터: camelCase로 저장 (erCd, equipNm, spec, price, unit, remark, paymentStandard, managerDepartment, managerId)
 * 저장 시 서버 요청: PascalCase (서버가 기대하는 형식)
 */
export const PPE_BASIC_01_Schema = {
  fields: {
    // 그리드 데이터: camelCase로 저장
    erCd: { initial: '', label: '보호구코드' },
    equipNm: { initial: '', label: '보호구명', required: 'Y' },
    spec: { initial: '', label: '규격' },
    price: { initial: 0, label: '단가' },
    unit: { initial: '', label: '단위' },
    paymentStandard: { initial: '', label: '교체주기' },
    useDepartmentScope: { initial: 'SELECTED', label: '사용부서범위' },
    managerDepartment: { initial: '', label: '사용부서' },
    managerDepartments: { initial: [], label: '사용부서목록' },
    managerDepartmentNames: { initial: '', label: '사용부서명' },
    managerId: { initial: '', label: '담당자' },
    remark: { initial: '', label: '비고' },
    stockQty: { initial: 0, label: '재고' },
    fileName: { initial: '', label: '첨부' },
    saveName: { initial: '', label: '첨부 저장파일명' },
    filePath: { initial: '', label: '첨부 경로' },
    previewFilePath: { initial: '', label: '첨부 미리보기 경로' },
  },

  mapper: {
    // 보호구 등록 조회
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },

    // 담당자 조회
    search2: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },

    // 부서 조회
    search3: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: (_, context) => Commons.EncryptAES('') || '',
    },

    save1: {
      ErCd: (row) => {
        const erCd = row.erCd || '';
        return Commons.EncryptAES(erCd) || '';
      },
      CustCd: (_, context) => {
        const custCd = context.search?.custCd || '';
        return Commons.EncryptAES(custCd) || '';
      },
      EquipNm: (row) => {
        const equipNm = row.equipNm || '';
        return Commons.EncryptAES(equipNm) || '';
      },
      Spec: (row) => {
        const spec = row.spec || '';
        return Commons.EncryptAES(spec) || '';
      },
      Price: (row) => {
        // Price는 int로 변환되므로 숫자 형태로 문자열 변환 후 암호화
        const priceValue = row.price ?? 0;
        return Commons.EncryptAES(String(priceValue)) || '';
      },
      Unit: (row) => {
        const unit = row.unit || '';
        return Commons.EncryptAES(unit) || '';
      },
      PaymentStandard: (row) => {
        const paymentStandard = row.paymentStandard || '';
        return Commons.EncryptAES(paymentStandard) || '';
      },
      UseDepartmentScope: (row) => {
        const useDepartmentScope = row.useDepartmentScope || 'SELECTED';
        return Commons.EncryptAES(useDepartmentScope) || '';
      },
      ManagerDepartment: (row) => {
        const managerDepartments = Array.isArray(row.managerDepartments)
          ? row.managerDepartments
          : String(row.managerDepartments || row.managerDepartment || '')
              .split(',')
              .map((v) => v.trim())
              .filter(Boolean);
        const managerDepartment = managerDepartments[0] || '';
        return Commons.EncryptAES(managerDepartment) || '';
      },
      ManagerDepartments: (row) => {
        const managerDepartments = Array.isArray(row.managerDepartments)
          ? row.managerDepartments
          : String(row.managerDepartments || row.managerDepartment || '')
              .split(',')
              .map((v) => v.trim())
              .filter(Boolean);
        return Commons.EncryptAES(managerDepartments.join(',')) || '';
      },
      ManagerId: (row) => {
        const managerId = row.managerId || '';
        return Commons.EncryptAES(managerId) || '';
      },
      Remark: (row) => {
        const remark = row.remark || '';
        return Commons.EncryptAES(remark) || '';
      },
      StockQty: (row) => {
        const n = Number(row.stockQty);
        const stockQty = Number.isFinite(n) ? Math.max(0, Math.trunc(n)) : 0;
        return Commons.EncryptAES(String(stockQty)) || '';
      },
      FilePath: (row, context) => {
        const previewPath = row.previewFilePath || '';
        if (previewPath) {
          const saveName = previewPath.split('/').pop() || '';
          const custCd = context.search?.custCd || '';
          const finalPath = `PPEManagement/${custCd}/PPE_BASIC_01/${saveName}`;
          return Commons.EncryptAES(finalPath) || '';
        }
        const existing = row.filePath || '';
        if (!existing) return '';
        return Commons.EncryptAES(existing) || '';
      },
      FileName: (row) => {
        const fileName = row.fileName || '';
        return Commons.EncryptAES(fileName) || '';
      },
      UserId: (_, context) => {
        // UserId는 필수 필드
        const userId = context.userInfo?.userid || '';
        return userId || '';
      },
    },

    // 보호구 등록 삭제
    delete1: {
      ErCd: (row) => Commons.EncryptAES(row.erCd || '') || '',
    },
  },
};
